export default __webpack_public_path__ + "static/media/banner4.e82480d9.jpg";